import $screen from 'wee-screen';
import { RouteHandler } from 'wee-routes';
import { makeCarousel } from '../flickity';

export default new RouteHandler({
    init() {
        let carousel;

        $screen.map([
            {
                max: 3,
                callback() {
                    if (! carousel) {
                        carousel = makeCarousel('[data-ref="scrollableList"]', '-homepage');
                    }
                },
            },
            {
                min: 4,
                callback() {
                    if (carousel) {
                        carousel.destroy();
                        carousel = null;
                    }
                },
            },
        ]);
    },
});